import React from 'react'
import clsx from 'clsx'
import { Box } from '@material-ui/core'
import { useStyle } from './Style'
import { CardsProps } from './Type'

export const LayoutCards: React.FC<CardsProps> = ({
  className,
  children,
  strongShadow,
  ...props
}): React.ReactElement => {
  const classes = useStyle()

  return (
    <Box
      width="100%"
      height="100%"
      className={clsx(classes.container, strongShadow && classes.strongShadow, className)}
      {...props}
    >
      {children}
    </Box>
  )
}
